import { faqItems } from "@/mocks/faq";
import { useState } from "react";

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4 whitespace-nowrap">
            Perguntas Frequentes
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Tudo Sobre CSSBuySpreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            As dúvidas mais comuns sobre nossa planilha, segurança e como comprar da China
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFaq(item.id)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4 flex-1">
                  <strong>{item.question}</strong>
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openId === item.id ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openId === item.id && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}